import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { EmployeeBlogArticleHit } from './EmployeeBlogArticleHit';
import { StandardArticleHit } from './StandardArticleHit';
import { HitProps } from '../_types';
import { isEmployeeBlog } from 'lib/util/employee-blog-utils';

export const ArticleHit = ({ hit }: HitProps) => {
  const { sitecoreContext } = useSitecoreContext();

  return isEmployeeBlog(sitecoreContext) ? (
    <EmployeeBlogArticleHit hit={hit} />
  ) : (
    <StandardArticleHit hit={hit} />
  );
};
